import { ArrowRight } from "lucide-react";
import { Logo } from "./Header";
import { companyInfo } from "../mock";

const footerLinks = [
  { label: "Home", target: "top" },
  { label: "Wat we doen", target: "#wat-we-doen" },
  { label: "Diensten", target: "#diensten" },
  { label: "Categorieën", target: "#categorieen" },
];

const FooterCta = ({ onContact, onSignup }) => {
  const scrollTo = (target) => {
    if (target === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    const el = document.querySelector(target);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <section className="ws-cta">
        <h2>
          <span className="lime">WS Global Trading:</span> uw partner in elektronica
        </h2>
        <p>
          Van sourcing tot levering: wij regelen het complete traject achter de
          schermen — kwaliteitscontrole, logistiek en betalingsvoorwaarden — zodat
          jij je kan richten op je business.
        </p>
        <div className="ws-cta-actions">
          <button className="ws-btn ws-btn-lime" onClick={onSignup}>
            Vraag account aan <ArrowRight size={17} className="arrow-icon" />
          </button>
          <button className="ws-btn ws-btn-outline" onClick={onContact}>
            Neem contact op <ArrowRight size={17} className="arrow-icon" />
          </button>
        </div>
      </section>

      <footer className="ws-footer">
        <div className="ws-footer-inner">
          <Logo onClick={() => scrollTo("top")} />
          <nav className="ws-footer-nav">
            {footerLinks.map((link) => (
              <a key={link.label} onClick={() => scrollTo(link.target)}>
                {link.label}
              </a>
            ))}
            <a onClick={onContact}>Contact</a>
          </nav>
          <div className="ws-footer-contact">
            {companyInfo.address}
            <br />
            {companyInfo.postal}
            <br />
            <a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a>
          </div>
        </div>
        <div className="ws-footer-copy">
          Copyright © 2025 {companyInfo.name} | Alle rechten voorbehouden
        </div>
      </footer>
    </>
  );
};

export default FooterCta;
